import { Component, OnInit } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { DialogDataService } from '../../dialog/dialog-data.service';
import { ColumnDefinition, TableFilterItem, TableSearchCriteria } from '../../tables/table.types';
import { CourseDialogData } from '../roster.types';
import { CourseChangeLog } from './view-log.types';

@Component({
    selector: 'app-roster-view-log',
    templateUrl: './view-log.component.html',
    styleUrls: ['./view-log.component.scss']
})
export class ViewLogComponent implements OnInit {
    tableName: string = 'courseChangeLog';
    baseUrl: string = 'courseChangeLog';
    criteria: TableSearchCriteria;
    filters: Array<TableFilterItem> = [
        {
            property: nameof<CourseChangeLog>((m) => m.studentId),
            inputType: 'input'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.firstName),
            inputType: 'input'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.lastName),
            inputType: 'input'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.logMessage),
            inputType: 'input'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.dateCreated),
            inputType: 'date-range'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.lastUpdated),
            inputType: 'date-range'
        }
    ];

    columns: Array<ColumnDefinition> = [
        {
            property: nameof<CourseChangeLog>((m) => m.id)
        },
        {
            property: nameof<CourseChangeLog>((m) => m.studentId)
        },
        {
            property: nameof<CourseChangeLog>((m) => m.firstName),
            disableSort: true
        },
        {
            property: nameof<CourseChangeLog>((m) => m.lastName),
            disableSort: true
        },
        {
            property: nameof<CourseChangeLog>((m) => m.logMessage)
        },
        {
            property: nameof<CourseChangeLog>((m) => m.dateCreated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: nameof<CourseChangeLog>((m) => m.lastUpdated),
            isDate: true,
            dateFormat: 'short'
        }
    ];

    constructor(private dataService: DialogDataService<CourseDialogData>) {
        this.criteria = {
            sortDirection: 'desc',
            sortBy: nameof<CourseChangeLog>((m) => m.lastUpdated),
            termCode: dataService.data.termCode,
            crn: dataService.data.crn
        };
    }

    ngOnInit(): void {}
}
